export default __webpack_public_path__ + "static/bandwidth-2-b5d65b8480908cfd09285110a2a74ef3.png";